import { useEffect, useState } from "react";
import { getDaysBeforeStart, getRemainingDays } from "../utils/date";

const usePrograms = ({ programs }) => {
    const [programsList, setProgramsList] = useState([]);
    const [detailedProgramsList, setDetailedProgramsList] = useState([]);

    useEffect(() => {

        let list = [], list2 = [];

        programs?.map((p) => {
            if (p?.beginner || p?.moderate || p?.advanced) {
                if (p?.beginner) {
                    list.push({
                        name: p?.title + " Beginner",
                        id: p?.id,
                        level: 1,
                        type: p?.type,
                        key: `${p?.id}-1`
                    })
                    list2.push({
                        ...p,
                        name: p?.title + " Beginner",
                        id: p?.id,
                        level: 1,
                        type: p?.type,
                        key: `${p?.id}-1`
                    })
                }

                if (p?.moderate) {
                    list.push({
                        name: p?.title + " Moderate",
                        id: p?.id,
                        level: 2,
                        type: p?.type,
                        key: `${p?.id}-2`
                    })
                    list2.push({
                        ...p,
                        name: p?.title + " Moderate",
                        id: p?.id,
                        level: 2,
                        type: p?.type,
                        key: `${p?.id}-2`
                    })
                }

                if (p?.advanced) {
                    list.push({
                        name: p?.title + " Advanced",
                        id: p?.id,
                        level: 3,
                        type: p?.type,
                        key: `${p?.id}-3`
                    })
                    list2.push({
                        ...p,
                        name: p?.title + " Advanced",
                        id: p?.id,
                        level: 3,
                        type: p?.type,
                        key: `${p?.id}-3`
                    })
                }
            } else {
                list.push({
                    name: p?.title,
                    id: p?.id,
                    level: 0,
                    type: p?.type,
                    key: p?.id
                })
                list2.push({
                    ...p,
                    name: p?.title,
                    id: p?.id,
                    level: 0,
                    type: p?.type,
                    key: p?.id
                })
            }
        })

        setProgramsList(list);
        setDetailedProgramsList(list2);

    }, [programs]);

    const GetSelectedPrograms = (programKeys) => {
        return detailedProgramsList.filter((p) => {
            const key = p?.id + (p?.level && p?.level != 0 ? ("-" + p?.level) : "");
            return programKeys?.includes(key)
        });
    }

    return {
        programsList,
        detailedProgramsList,
        GetSelectedPrograms,
    };
}

export default usePrograms;
